export const PRODUCTS = [
  {
    id: 'tshirt_210', category: 'textile', packs: ['essential'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'tshirt_110', category: 'textile', packs: ['performance', 'premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'medal_6cm', category: 'medals', packs: ['performance'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'medal_7cm', category: 'medals', packs: ['premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'medal_custom', category: 'medals', packs: ['custom'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'cup_silicon', category: 'hydration', packs: ['all'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'cup_pp', category: 'hydration', packs: ['all'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'flask_150', category: 'hydration', packs: ['all'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'flask_250', category: 'hydration', packs: ['all'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'buff_poly', category: 'accessories', packs: ['essential'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'buff_icesilk', category: 'accessories', packs: ['performance', 'premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'cap_5p_1c', category: 'accessories', packs: ['essential'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'cap_56p_2c', category: 'accessories', packs: ['performance'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'cap_emb', category: 'accessories', packs: ['premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'socks', category: 'accessories', packs: ['all'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'backpack', category: 'bags', packs: ['performance', 'premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'totebag', category: 'bags', packs: ['custom'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'sachet_zip', category: 'packaging', packs: ['premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
  {
    id: 'box_premium', category: 'packaging', packs: ['premium'],
    image: 'https://images.pexels.com/photos/7267538/pexels-photo-7267538.jpeg?auto=compress&cs=tinysrgb&w=400',
  },
];

export const PLANNING_DATA = [
  { key: 'tshirt',   essential: '10j + 30j', performance: '15j + 30j', premium: '20j + 60j' },
  { key: 'cup',      essential: '10j + 15j', performance: '15j + 20j', premium: '20j + 30j' },
  { key: 'buff',     essential: '5j + 15j',  performance: '10j + 20j', premium: '15j + 30j' },
  { key: 'cap',      essential: '15j + 15j', performance: '20j + 30j', premium: '20j + 40j' },
  { key: 'socks',    essential: '15j + 15j', performance: '15j + 30j', premium: '20j + 40j' },
  { key: 'medal',    essential: '10j + 40j', performance: '15j + 60j', premium: '20j + 60j' },
  { key: 'backpack', essential: null,         performance: '15j + 30j', premium: '20j + 40j' },
  { key: 'packaging',essential: null,         performance: null,         premium: '20j + 30j' },
];
